export const MEGA_TOOLBAR = 'mega-toolbar';
export const PLUGINS_ORIENTATIONS_SWITCH = 'plugins-orientations-switch';
export const FORMATTING_ORIENTATIONS_SWITCH = 'formatting-orientations-switch';
